import { Card, Grid, Paper, Stack, Typography } from "@mui/material";
import { useGetSalesRepDiscountsQuery, useGetSalesRepFindersQuery } from "../../features/model/salesrepSlice";
import Loading from "../../components/Loading";
import { formatPhone } from "../../helpers/strings";
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc';
import { SalesRepOrdersListView } from "../../components/OrdersListView";
import { AddDiscountCard, DiscountCard } from "./DiscountView";

dayjs.extend(utc);

const FinderItem = ({finder, contracts, salesrep, admin}) => {
    const {data: discounts, error: discountsError, isLoading: isLoadingDiscounts} = useGetSalesRepDiscountsQuery(finder.id)

    if (discountsError) {
        return <div>{discountsError.error}</div>;
    }
    if (isLoadingDiscounts) {
        return <Loading />
    }
    var phonenumber = ""
    let metadata = JSON.parse(finder.metadata)
    if("phone" in metadata) {
        phonenumber = metadata["phone"]
        phonenumber = formatPhone(phonenumber)
    }
    var allDiscountObjects = []
    if (discounts) {
        allDiscountObjects = discounts.objects
    }

    return <Grid item>
        <Paper sx={{margin: 2, padding: 2}}>
            <Stack direction="column">
            <Typography variant="h3">{finder.name}</Typography>
            <Typography variant="p">{finder.email}</Typography>
            <Typography variant="p">{phonenumber}</Typography>
            <Typography variant="subtitle2">Registered {dayjs.utc(finder.added).local().format("M/D/YYYY")}</Typography>
            <Paper>
                <Card>
                    <Stack direction="column" sx={{margin: 2}} spacing={2}>
                    <Typography variant='h2'>Customer codes</Typography>
                    {
                        allDiscountObjects.map((discount, i) => <DiscountCard key={discount.id} discount={discount} />)
                    }
                    <AddDiscountCard salesrep={finder} />
                    </Stack>
                </Card>
            </Paper>

            <SalesRepOrdersListView contracts={contracts} salesrep={salesrep} discounts={discounts.objects.map((discount, i) => discount.id)} admin={admin} />
            </Stack>
        </Paper>
    </Grid>
}

const SalesRepFindersListView = ({salesrep, contracts, admin}) => {
    const {data, error, isLoading } = useGetSalesRepFindersQuery(salesrep.id)

    if(isLoading) return <Loading />
    if(error) return <></>
    if(!(data.objects)) return <></>
    
    return <Paper>
        <Card>
           <Stack direction="column" sx={{margin: 2}} spacing={2}>
                <Typography variant='h2'>Registered distributors</Typography>
                <Grid container>
                    {data.objects.map((rep, i) => <FinderItem contracts={contracts} key={rep.id} salesrep={salesrep} finder={rep} admin={admin}/>)}
                </Grid>
            </Stack>
        </Card>
    </Paper>

}

export { SalesRepFindersListView };